import type { SectionColor } from "../risikoanalyseStep/types";

export type ContractSectionKey =
  | "allgemein"
  | "risiken"
  | "vereinbarung"
  | "umfang"
  | "beitraege";

export type ContractMasterSection = {
  key: ContractSectionKey;
  title: string;
  shortTitle: string;
  color: SectionColor;
};

export const CONTRACT_MASTER_SECTIONS: ReadonlyArray<ContractMasterSection> = [
  {
    key: "allgemein",
    title: "Allgemeine Informationen",
    shortTitle: "Allgemein",
    color: "purple",
  },
  {
    key: "risiken",
    title: "Risikoinformationen",
    shortTitle: "Risiken",
    color: "orange",
  },
  {
    key: "vereinbarung",
    title: "Vereinbarung mit dem Versicherer",
    shortTitle: "Vereinbarung",
    color: "black",
  },
  {
    key: "umfang",
    title: "Versicherungsumfang",
    shortTitle: "Umfang",
    color: "green",
  },
  {
    key: "beitraege",
    title: "Vertragsdaten und Zahlung",
    shortTitle: "Vertragsdaten",
    color: "pillarOrange",
  },
];
